import jwtoken from "jsonwebtoken";
import { userService } from "../_services/user.service";
import { resetService } from "../_services/reset.service";
import { router } from "../_helpers";

const user_session = JSON.parse(localStorage.getItem("user"));
const isAuthentificated = JSON.parse(localStorage.getItem("isAuthentificated"));

const initialStateDefault = () => {
  return {
    jwt: user_session
      ? jwtoken.decode(user_session.token, { complete: true })
      : null,
    user: user_session ? user_session.user : null,
    status: user_session
      ? { status: { loggedIn: true }, user_session }
      : { status: {}, user_session: null },
    remember_me: user_session ? true : false,
    isAuthentificated: isAuthentificated ? isAuthentificated : false
  };
};

const tokenIsExpired = () => {
  if (!user_session) {
    return true;
  } else {
    try {
      let payload = jwtoken.decode(user_session.token, { complete: true })
        .payload;
      
      return new Date(payload.exp * 1000).getTime() <= Date.now();
    } catch (error) {
      
    }
  }
};

export const authentication = {
  namespaced: true,
  state: {
    jwt: initialStateDefault().jwt,
    isAuthentificated:
      initialStateDefault().isAuthentificated && !tokenIsExpired(),
    status: initialStateDefault().status,
    user: initialStateDefault().user,
    remember_me: initialStateDefault().remember_me
  },
  getters: {
    getId: (state, getters) => {
      if (getters.getJWTpayload != null) {
        return getters.getJWTpayload.user_id;
      } else {
        return null;
      }
    },
    getUser: state => {
      // return {username: 'Augustin'}; //IF NOT AUTH 
      return state.user;
    },
    getJWT: state => {
      return state.jwt;
    },
    getJWTpayload: state => {
      return state.jwt.payload;
    },
    // getDateExpired: state => {
    //   if (state.jwt) {
    //     return (new Date(state.jwt.payload.exp * 1000));
    //   } else {
    //     return null;
    //   }
    // },
    getStatus: state => {
      if (state.status) {
        return state.status;
      } else {
        return null;
      }
    },
    isAuthentificated: state => {
      // return true; //IF NOT AUTH
      return state.isAuthentificated;
    },
    // isExpired: (state, getters) => {
    //   if (getters.getDateExpired != null) {
    //     return getters.getDateExpired.getTime() <= Date.now();
    //   } else {
    //     return null;
    //   }
    // },
    isRememberMe: state => {
      return state.remember_me;
    }
  },
  mutations: {
    setAuthentificated(state, isAuthentificated) {
      state.isAuthentificated = isAuthentificated;
    },
    setRememberMe(state, remember_me) {
      state.remember_me = remember_me;
    },
    setJWT(state, jwt) {
      // state.jwt = jwt ? jwtoken.decode(jwt,{ complete: true }) : {};
      state.jwt = jwt;
    },
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = {};
      state.jwt = {};
    }
  },
  actions: {
    login({ dispatch, commit }, { username, password, remember_me }) {
      userService.login(username, password).then(responseUser => {
        // login successful if there's a jwt token in the responseHow to make a remember me checkbox with Vue.js? -
        if (responseUser.token && responseUser.user) {
          commit("loginSuccess", responseUser.user);
          commit("setJWT", responseUser.token);
          commit("setAuthentificated", true);
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          commit("setRememberMe", true);
          localStorage.setItem("user", JSON.stringify(responseUser));
          localStorage.setItem("isAuthentificated", true);
        }
        router.push("/home");
      }),
        error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        };
    },
    logout({ commit, getters }) {
      commit("logout");
      userService.postlogout().then(response => {
        // If rememberMe is not active then delete user and authentication
        if (!getters.isRememberMe) {
          localStorage.removeItem("user");
          localStorage.removeItem("isAuthentificated");
        } else {
          // refresh authentication
          localStorage.setItem("isAuthentificated", false);
        }
        commit("setAuthentificated", false);
        router.go("login");
      }),
        error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        };
    },
    resetPassword({ dispatch, commit, getters }, email) {
      resetService.reset(email).then(response => {
        
      });
    },
  }
};
